import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { api } from "shared/api";

declare global {
  interface Window {
    vo?: {
      kvk?: string;
    };
  }
}

const fetchDealerDiscounts = async (kvk: string) => {
  const response = await api().gersGetDealerDiscountsByKVK(kvk);
  return response.data;
};

export const useDealerDiscounts = (doorOriginalPrice: number = 0) => {
  // Get the kvk from the global window object from statamic
  const kvk = window.vo?.kvk;

  const {
    data: dealerDiscounts,
    isLoading: isLoadingCall,
    isError,
    status,
  } = useQuery({
    queryKey: ["fetch-dealer-discounts", kvk],
    queryFn: () => fetchDealerDiscounts(kvk!),
    enabled: !!kvk && typeof kvk === "string",
  });

  // Loading state
  const isDealerDiscountsLoading = window.vo?.kvk && isLoadingCall && isError;

  // Find the discount for the specific product code
  const businessDoorDiscounts = useMemo(() => {
    return dealerDiscounts?.find(
      (discount) => discount.productCode === "d-product",
    );
  }, [dealerDiscounts]);

  // Calculate the discount percentage for the specific product code
  const businessDoorDiscount = businessDoorDiscounts?.discount ?? 0;

  // Calculate the discounted price
  const businessDoorDiscountsPrice =
    doorOriginalPrice - (doorOriginalPrice * businessDoorDiscount) / 100;

  // Calculate the saved amount
  const savedAmount = (doorOriginalPrice - businessDoorDiscountsPrice).toFixed(
    2,
  );

  return {
    dealerDiscounts,
    isError,
    isDealerDiscountsLoading,
    doorOriginalPrice,
    businessDoorDiscount,
    businessDoorDiscountsPrice,
    savedAmount,
    status,
  };
};
